import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import finishActivation from '../../../assets/images/logo_2.png'
import Button from '../../../components/Button'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import { procedureComplete } from '../../../redux/actions'

const NominativitySuccess = () => {
  const { setBlockNavigation }: any = useAppContext()
  const history = useHistory()

  const nomLineForm = useSelector((state: any) => state.nomLineForm)

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onContinue = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/nominatividad')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <div className="landing-container">
        <img
          id="data-confirmation-img-valid-ok"
          alt="finished activation"
          src={finishActivation}
          style={{ maxHeight: '160px' }}
        />
        <h3>
          <strong id="nueva-portabilidad-strong-felicitaciones">
            La activación se <br />
            registró exitosamente
          </strong>
        </h3>
        <p className="recomendaciones">
          El número de línea es <br /> <strong>{nomLineForm.lineNumber}</strong>
        </p>
        <Button
          id="nominativity-success-back-to-start"
          className="link-button"
          handleSubmit={onContinue}
          label="Ir al inicio"
        />
      </div>
    </main>
  )
}

export default NominativitySuccess
